<template>
  <div
    v-if="showModal"
    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center p-4"
  >
    <div class="confirm-dialog max-w-[512px] w-full shadow-lg rounded-md bg-white">
      <h3
        v-if="target_auth_type === 0"
        class="text-center sm:text-left ml-6 mt-7 mb-5"
      >
        {{ $t('messages.switch_2FA_modal.title_google') }}
      </h3>
      <h3
        v-else
        class="text-center sm:text-left ml-6 mt-7 mb-5"
      >
        {{ $t('messages.switch_2FA_modal.title_email') }}
      </h3>
      <p
        v-if="target_auth_type === 0"
        class="b1 ml-6 mr-6 text-zyxel-gray-800"
      >
        {{ $t('messages.switch_2FA_modal.description_google') }}
      </p>
      <p
        v-else
        class="b1 ml-6 mr-6 text-zyxel-gray-800"
      >
        {{ $t('messages.switch_2FA_modal.description_email') }}
      </p>
      <div class="hidden sm:flex justify-end mt-[56px]">
        <button
          class="button-cancel mb-6 px-4 py-2 rounded mr-3"
          @click="cancel"
        >
          {{ $t('messages.button.cancel') }}
        </button>
        <button
          class="button-primary mb-6 mr-6 px-4 py-2 rounded"
          @click="switch2fa"
        >
          {{ $t('messages.button.switch') }}
        </button>
      </div>
      <div class="flex-col sm:hidden mt-[42px] p-6">
        <button
          class="button-primary w-full mb-4 rounded"
          @click="switch2fa"
        >
          {{ $t('messages.button.switch') }}
        </button>
        <button
          class="button-cancel w-full mb-6 rounded"
          @click="cancel"
        >
          {{ $t('messages.button.cancel') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Switch2FAModal',
    props: {
        showModal: Boolean,
        target_auth_type: Number,
    },
    methods: {
        cancel() {
            this.$emit('close-modal');
        },
        switch2fa() {
            this.$emit('switch2fa')
        }
    }
}
</script>